import { useOrganizationsStore } from '@/stores/organizations';
import { useUsersStore } from '@/stores/users';
import { EOrganizationProvisioningType } from '@/types/organizations';

/**
 * Resolves whether the current user can open the Organization Reporting
 * page: the current organization must be provisioned by consults per month,
 * and the user must be a super admin or an admin of that organization.
 * @returns Whether the user has access to the current organization's
 * reporting.
 */
export const useOrganizationReportingAccess = () => {
  const currentOrganization = useOrganizationsStore(
    (state) => state.currentOrganization,
  );
  const organizationId = currentOrganization?.id;

  const { isSuperAdmin, isOrgAdmin } = useUsersStore((state) => ({
    isSuperAdmin: state.checkIsSuperAdmin(),
    isOrgAdmin: !!organizationId && state.checkIsOrgAdmin(organizationId),
  }));

  const isConsultsPerMonth =
    currentOrganization?.provisioning?.type ===
    EOrganizationProvisioningType.CONSULTS_PER_MONTH;

  return {
    hasAccess: isConsultsPerMonth && (isSuperAdmin || isOrgAdmin),
  };
};
